var adresseBo = {
    voie1: '',
    voie2: '',
    codePostal: '',
    ville: ''
}

export default adresseBo;


// WEBPACK FOOTER //
// ./src/components/data/Adresse.js